import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

export interface ISeoConfig {
  titleKey: string;
  descriptionKey: string;
  ogTitleKey?: string;
  ogDescriptionKey?: string;
}

@Injectable({ providedIn: 'root' })
export class SeoService {
  readonly #title = inject(Title);
  readonly #meta = inject(Meta);

  setTitle(title: string): void {
    if (!title) {
      return;
    }
    this.#title.setTitle(title);
  }

  setTag(key: string, value: string, type: 'name' | 'property'): void {
    if (!value) {
      return;
    }

    this.#meta.updateTag({
      [type]: key,
      content: value,
    });
  }
}
